var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadDicom = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  viewBox: "0 -2 30 30",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M28 16a2 2 0 0 0-2 2v4H4v-4a2 2 0 0 0-4 0v7c0 .479.521 1 1 1h28c.604 0 1-.458 1-1v-7a2 2 0 0 0-2-2M11 8h2v9a2 2 0 0 0 4 0V8h2c.704 0 1.326.095 1.719-.3a1.013 1.013 0 0 0 0-1.426L15.776.283a.99.99 0 0 0-.76-.285.98.98 0 0 0-.76.285L9.313 6.274a1.01 1.01 0 0 0 0 1.426c.392.395 1.295.3 1.687.3"
})));
export { SvgUploadDicom as ReactComponent };
export default __webpack_public_path__ + "assets/images/upload-dicom.svg";